import React, {
  useState,
} from 'react';

import {
  Alert,
  Box,
} from '@mui/material';

import {
  useDispatch,
} from 'react-redux';

import {
  useNavigate,
} from 'react-router-dom';

import {
  setCredentials,
} from './authSlice';

import {
  useGoogleLoginMutation,
} from './authApiSlice';

import GoogleCredentialButton
  from './GoogleCredentialButton';


const GoogleSignInButton = () => {
  const dispatch =
    useDispatch();

  const navigate =
    useNavigate();

  const [
    error,
    setError,
  ] =
    useState('');

  const [
    googleLogin,
    {
      isLoading,
    },
  ] =
    useGoogleLoginMutation();


  const handleCredential =
    async (credential) => {
      setError('');

      try {
        /*
         * ONLY the explicit Google button
         * calls /auth/google.
         */
        const result =
          await googleLogin(
            credential
          ).unwrap();


        dispatch(
          setCredentials({
            accessToken:
              result.accessToken,
          })
        );


        /*
         * Organization setup is handled by
         * the dashboard modal now.
         *
         * Google-only purchased accounts
         * must never be sent to a password
         * reset page just because
         * isFirstLogin=true.
         */
        navigate(
          '/console',
          {
            replace: true,
          }
        );
      } catch (err) {
        console.error(
          'Google sign in failed:',
          err
        );

        setError(
          err?.data?.message ||
          'Unable to sign in with Google.'
        );
      }
    };


  return (
    <Box>
      {error && (
        <Alert
          severity="error"
          sx={{
            mb: 2,
          }}
        >
          {error}
        </Alert>
      )}

      <GoogleCredentialButton
        onCredential={
          handleCredential
        }

        disabled={
          isLoading
        }

        text="signin_with"
      />
    </Box>
  );
};


export default GoogleSignInButton;